




























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class Overlay extends Vue {
  @Prop() private startDelay!: string;
  @Prop() private positionX!: string;
  @Prop() private positionY!: string;
  @Prop() private size!: string;
}
